import React from "react"
import numeral from "numeral"
//import I18n from "i18n-js/index.js.erb"
import CurrencyInput from "../CurrencyInput/CurrencyInput"

class ProductChargePanel extends React.Component {
    
    constructor(props) {
        super(props)
        this.productChargeOnChange = this.productChargeOnChange.bind(this);
        this.onChangeAmount = this.onChangeAmount.bind(this);
        this.onChangeApplyTaxesSwitch = this.onChangeApplyTaxesSwitch.bind(this);
        this.onChangeTaxesSelect = this.onChangeTaxesSelect.bind(this);
        this.onChangeGratuityAllowed = this.onChangeGratuityAllowed.bind(this);
    };

    render() {
        return(
            <div>
                {this.renderProductChargePanel(this.props.product, this.props.idx)}
                {this.renderChargeableForm(this.props.product, this.props.idx)}
            </div>
        );
    };

    renderProductChargePanel(product, idx) {
        return (
            <div>
                <h5 className="default-panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('charge')} </h5>
                <div className="row">
                    <div className="form-group">
                        <div className={this.props.read_only != true && this.props.remove ? "col-sm-12" : "col-sm-12"}>
                            <label>{I18n.t('forms')}</label>
                        </div>
                    </div>
                </div>
            </div>
        );

    }

    renderChargeableForm(product, idx) {
        return (
            <div style={{paddingTop: '5px'}}>
                <div className="card" >
                    <div className="row">
                        <div className="col-sm-12">
                            <label>{I18n.t('amount')}</label>
                            <div className="form-group">
                                {
                                    this.props.read_only || (this.props.mode != 'single' && product.id > 0)
                                        ?
                                        <div>${numeral(product.amount / 100).format(this.props.numberFormat)}</div>
                                        :
                                        <div>
                                          <CurrencyInput ignoreComponentWillReceiveProps={true} className={this.props.renderFieldClasses('amount')} value={product.amount} data-model="Product" data-column="amount" data-type="currency" data-min-length="0" onChange={this.onChangeAmount}/>
                                        </div>
                                }
                                {this.props.renderFieldErrors('amount')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    productChargeOnChange (value) {
        this.props.onChangeSwitch('product_charge', value);
    };

    onChangeApplyTaxesSwitch(value) {
        this.props.onChangeSwitch('is_taxable', value);
    };

    onChangeAmount(value) {
        this.props.onChangeSwitch('amount', value);
    };

    onChangeTaxesSelect(value) {

        this.props.onChangeSwitch('taxes', value);
    };

    onChangeGratuityAllowed(value) {
        this.props.onChangeSwitch('gratuity_allowed', value);
    }
};

export default ProductChargePanel